module.exports = __webpack_public_path__ + "static/media/SPMS_IC_Logo.53b8e513.png";